import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { BarChart3, CalendarCheck, PhoneCall, Mail, Users, FileText, LifeBuoy, Newspaper, Briefcase, Settings, GraduationCap, Search } from "lucide-react";
import CoursesAdmin from "../components/admin/CoursesAdmin";
import SeoAdmin from "../components/admin/SeoAdmin";
import PanelShell from "../components/panel/PanelShell";
import AdminOverview from "../components/admin/AdminOverview";
import LeadsTable from "../components/admin/LeadsTable";
import { ClientsAdmin, ReportsAdmin, SupportAdmin } from "../components/admin/ClientAdmin";
import { BlogAdmin, ServicesAdmin, SettingsAdmin } from "../components/admin/ContentAdmin";
import { useAuth } from "../context/AuthContext";
import Seo from "../components/Seo";

const NAV = [
  { key: "overview", label: "Analytics", icon: BarChart3 },
  { key: "consultations", label: "Consultation Bookings", icon: CalendarCheck },
  { key: "callbacks", label: "Callback Requests", icon: PhoneCall },
  { key: "enquiries", label: "Customer Enquiries", icon: Mail },
  { key: "clients", label: "Client Accounts", icon: Users },
  { key: "reports", label: "Client Reports", icon: FileText },
  { key: "support", label: "Support Requests", icon: LifeBuoy },
  { key: "blog", label: "Blog Posts", icon: Newspaper },
  { key: "courses", label: "Courses", icon: GraduationCap },
  { key: "services", label: "Financial Services", icon: Briefcase },
  { key: "seo", label: "Search & Indexing", icon: Search },
  { key: "settings", label: "Website Content", icon: Settings },
];

export default function Admin() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [tab, setTab] = useState("overview");
  const views = {
    overview: <AdminOverview />,
    consultations: <LeadsTable key="consultations" kind="consultations" />,
    callbacks: <LeadsTable key="callbacks" kind="callbacks" />,
    enquiries: <LeadsTable key="enquiries" kind="enquiries" />,
    clients: <ClientsAdmin />,
    reports: <ReportsAdmin />,
    support: <SupportAdmin />,
    blog: <BlogAdmin />,
    courses: <CoursesAdmin />,
    services: <ServicesAdmin />,
    seo: <SeoAdmin />,
    settings: <SettingsAdmin />,
  };
  return (
    <PanelShell label="Admin Console" nav={NAV} active={tab} onChange={setTab} user={user} onLogout={async () => { await logout(); navigate("/admin/login"); }}>
      <Seo title="Admin" noindex />
      <div data-testid={`admin-tab-${tab}`}>{views[tab]}</div>
    </PanelShell>
  );
}
